import { render, staticRenderFns } from "./TuitionDraftInvoice.vue?vue&type=template&id=63cb7e8b&scoped=true"
import script from "./TuitionDraftInvoice.vue?vue&type=script&lang=js"
export * from "./TuitionDraftInvoice.vue?vue&type=script&lang=js"
import style0 from "./TuitionDraftInvoice.vue?vue&type=style&index=0&id=63cb7e8b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cb7e8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63cb7e8b')) {
      api.createRecord('63cb7e8b', component.options)
    } else {
      api.reload('63cb7e8b', component.options)
    }
    module.hot.accept("./TuitionDraftInvoice.vue?vue&type=template&id=63cb7e8b&scoped=true", function () {
      api.rerender('63cb7e8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/TuitionDraftInvoice.vue"
export default component.exports